import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const FooterSection = () => {
  const navigate = useNavigate();
  const currentYear = new Date()?.getFullYear();

  const quickLinks = [
  { label: 'Home', path: '/home-landing' },
  { label: 'Menu', path: 'https://drive.google.com/file/d/1IaCoBWg1awgR1K-mMhs7nYbQZgbLT0Fa/preview' },
  { label: 'Durham', path: '/Durham' },
  { label: 'Chapel Hill', path: '/ChapelHill' },
  { label: 'Reservations', path: '/reservations' },
  { label: 'Catering', path: '/catering' },
  { label: 'Contact', path: '/contact' }];


  const socialLinks = [
  { name: 'Facebook', icon: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61550308602004' },
  { name: 'Instagram', icon: 'Instagram', url: 'https://www.instagram.com/kahloveramx/' }];


  const contactInfo = [
  {
    icon: 'MapPin',
    title: '',
    locations: [
    {
      subheader: 'Chapel Hill',
      address: '504 Meadowmont Village Cir, Chapel Hill, NC 27517',
      mapsUrl: 'https://www.google.com/maps/search/?api=1&query=504+Meadowmont+Village+Cir+Chapel+Hill+NC+27517'
    },
    {
      subheader: 'Durham',
      address: '2812 Erwin Road, Durham, NC 27705',
      mapsUrl: 'https://www.google.com/maps/search/?api=1&query=2812+Erwin+Road+Durham+NC+27705'
    }]

  },
  {
    icon: 'Phone',
    title: 'Call Us',
    details: [
    { text: 'Chapel Hill: (984) 999-4537', phone: '9849994537' },
    { text: 'Durham: (919) 973-0028', phone: '9199730028' }]

  },
  {
    icon: 'Mail',
    title: 'Email',
    details: ['kahloveramexican@gmail.com']
  },
  {
    icon: 'Clock',
    title: 'Hours',
    details: ['Mon-Thu: 10AM-10PM', 'Fri-Sat: 10AM-11PM', 'Sun: 10AM-9PM']
  }];


  const handleNavigation = (path) => {
    if (path?.startsWith('http')) {
      window.open(path, '_blank');
    } else {
      navigate(path);
    }
  };

  return (
    <footer className="bg-secondary text-secondary-foreground">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Brand Section */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="lg:col-span-1">

            <div className="flex items-center space-x-2 mb-6">
              <div className="w-12 h-12 rounded-lg flex items-center justify-center overflow-hidden">
                <img src="/assets/images/logo_2_png_edited-1767119368116.png" alt="Kahlovera Street Tacos Logo" className="w-full h-full object-contain" />
              </div>
              <div>
                <h2 className="text-2xl font-heading font-bold text-accent">Kahlovera</h2>
                <p className="text-sm font-caption text-secondary-foreground/70 -mt-1">Mexican Bar & Grill</p>
              </div>
            </div>
            
            <p className="text-secondary-foreground/80 font-body mb-6 leading-relaxed">Bold Mexican food with heart. Serving Chapel Hill & Durham with pride, passion, and flavors that bring people together.

            </p>

            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks?.map((social) =>
              <a
                key={social?.name}
                href={social?.url}
                className="w-10 h-10 bg-secondary-foreground/10 rounded-lg flex items-center justify-center hover:bg-accent hover:scale-110 transition-all duration-300 group">

                  <Icon
                  name={social?.icon}
                  size={20}
                  className="text-secondary-foreground/70 group-hover:text-accent-foreground" />

                </a>
              )}
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}>

            <h3 className="text-lg font-heading font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks?.map((link) =>
              <li key={link?.label}>
                  <button
                  onClick={() => handleNavigation(link?.path)}
                  className="text-secondary-foreground/80 hover:text-accent font-body transition-colors duration-200 flex items-center space-x-2 group">

                    <Icon
                    name="ArrowRight"
                    size={14}
                    className="opacity-0 group-hover:opacity-100 transition-opacity duration-200" />

                    <span>{link?.label}</span>
                  </button>
                </li>
              )}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="md:col-span-2 lg:col-span-2">

            <h3 className="text-lg font-heading font-bold mb-6">Contact Information</h3>
            <div className="grid sm:grid-cols-2 gap-6">
              {contactInfo?.map((info) =>
              <div key={info?.title} className="flex space-x-3">
                  <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name={info?.icon} size={20} className="text-accent" />
                  </div>
                  <div>
                    {info?.title &&
                  <h4 className="font-body font-medium text-secondary-foreground mb-1">
                        {info?.title}
                      </h4>
                  }
                    {info?.locations ?
                  <div className="space-y-3">
                        {info?.locations?.map((location, index) =>
                    <div key={index}>
                            <p className="font-body font-medium text-secondary-foreground mb-1">
                              {location?.subheader}
                            </p>
                            <a
                        href={location?.mapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-secondary-foreground/80 hover:text-accent font-body text-sm transition-colors duration-200 underline">

                              {location?.address}
                            </a>
                          </div>
                    )}
                      </div> :

                  info?.details?.map((detail, index) =>
                  info?.icon === 'Phone' && typeof detail === 'object' ?
                  <p key={index} className="text-secondary-foreground/80 font-body text-sm">
                            {detail?.text?.split(':')?.[0]}:{' '}
                            <a
                              href={`tel:${detail?.phone}`}
                              className="hover:text-accent transition-colors duration-200 underline">
                              {detail?.text?.split(':')?.[1]?.trim()}
                            </a>
                          </p> :
                  info?.icon === 'Mail' ?
                  <a
                            key={index}
                            href={`mailto:${typeof detail === 'object' ? detail?.text : detail}`}
                            className="text-secondary-foreground/80 hover:text-accent font-body text-sm transition-colors duration-200 underline">
                            {typeof detail === 'object' ? detail?.text : detail}
                          </a> :
                  <p key={index} className="text-secondary-foreground/80 font-body text-sm">
                            {typeof detail === 'object' ? detail?.text : detail}
                          </p>

                  )
                  }
                  </div>
                </div>
              )}
            </div>
          </motion.div>
        </div>
      </div>
      {/* Bottom Bar */}
      <div className="border-t border-secondary-foreground/10 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col items-center">
            <p className="text-secondary-foreground/70 font-body text-sm text-center">
              © {currentYear} Kahlovera. Made by <a href="https://valinaire.com" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/80 transition-colors duration-200">Valinaire Agency</a>.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );

};

export default FooterSection;